import React, { useState, useEffect, useRef } from "react";
import { Stage, Layer, Image as KonvaImage } from "react-konva";
import useImage from "use-image";
import { useTranslation } from "react-i18next";
import { urls } from "../../services/apiService";
// Import icons (Replace with actual image paths)
const houseIconUrl = "https://img.icons8.com/?size=100&id=tNcJ7GGjHsUq&format=png&color=000000";
const waterIconUrl = "https://img.icons8.com/?size=100&id=13101&format=png&color=000000";
const soilIconUrl = "https://img.icons8.com/?size=100&id=WdpOiowt42I7&format=png&color=000000";
const roadIconUrl = "https://img.icons8.com/?size=100&id=19807&format=png&color=000000";

const icons = {
  house: houseIconUrl,
  water: waterIconUrl,
  soil: soilIconUrl,
  road: roadIconUrl
};

const ImageEditor = () => {
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [imageSize, setImageSize] = useState({ width: 100, height: 100 }); // Default size
  const [placemarks, setPlacemarks] = useState([]);
  const [selectedIcon, setSelectedIcon] = useState("house"); // Default icon
  const [loading, setLoading] = useState(false); // Default icon
  const { t, i18n } = useTranslation();
  const stageRef = useRef();

  const [uploadedImage] = useImage(imageUrl);

  // Handle image upload
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setImage(file);
      setImageUrl(url);
    }
  };
  useEffect(() => {
    if (imageUrl) {
      const img = new window.Image();
      img.src = imageUrl;
      img.onload = () => {
        setImageSize({ width: img.naturalWidth, height: img.naturalHeight });
      };
    }
  }, [imageUrl]);
  // Handle adding placemarks
  const handleAddPlacemark = (event) => {
    const stage = event.target.getStage();
    const pointerPos = stage.getPointerPosition();
    setPlacemarks([...placemarks, { x: pointerPos.x, y: pointerPos.y, type: selectedIcon }]);
  };

  const generatePDF = async () => {

    if (!image) {
      alert("Please upload an image first.");
      return;
    }
    setLoading(true);
    try {
      const stage = stageRef.current;
      const canvas = stage.toCanvas();
      const dataUrl = canvas.toDataURL("image/png");

      const reportData = JSON.parse(localStorage.getItem("report"));
      const fieldId = reportData?.fieldName; // fieldName is primary key in your DB

      if (!fieldId) {
        alert("Field ID missing, cannot save image!");
        setLoading(false);
        return;
      }

      const base64Image = dataUrl.replace(/^data:image\/png;base64,/, "");


      const response = await fetch(urls.saveFieldImage, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fieldId, image: base64Image }),
      });
      const htmlContent = `
      <html>
      <head><title>Placemarks Report</title></head>
      <body>
        <h2>Image with Placemarks</h2>
        <img src="${dataUrl}" width="500px" />
        <h3>Placemarks:</h3>
        <ul>
          ${placemarks
          .map((p, index) => `<li>Placemark ${index + 1} (${p.type}) at (${p.x}, ${p.y})</li>`)
          .join("")}
        </ul>
      </body>
      </html>
    `;
      // Store HTML content in localStorage
      localStorage.setItem("placemarkReport", htmlContent);

      const result = await response.json();
      setLoading(false);
      alert(result.success ? "Image saved successfully!" : "Image upload failed!");
    } catch (error) {
      setLoading(false);
      console.error("Upload error:", error);
      alert("Error uploading image.");

    }
  };


  return (
    <div style={{ textAlign: "center" }}>
      {/* <h2>Upload Image and Add Placemarks</h2> */}
      <input type="file" accept="image/*" onChange={handleImageUpload} className="w-full p-2 mt-1" />
      {uploadedImage && (

        <div style={{ marginTop: "10px" }}>
          <div className="mt-4">
            <label>{i18n.language === "ur" ? "آئیکن منتخب کریں:" : "Select Icon:"}</label>
            <select onChange={(e) => setSelectedIcon(e.target.value)} value={selectedIcon}>
              <option value="house">{i18n.language === "ur" ? "گھر" : "House"}</option>
              <option value="water">{i18n.language === "ur" ? "پانی" : "Water"}</option>
              <option value="soil">{i18n.language === "ur" ? "مٹی" : "Soil"}</option>
              <option value="road">{i18n.language === "ur" ? "سڑک" : "Road"}</option>
            </select>
          </div>



          <div style={{ border: "solid black", display: "inline-block", marginTop: "10px" }}>
            <Stage
              width={imageSize.width}
              height={imageSize.height}
              ref={stageRef}
              onClick={handleAddPlacemark}
              style={{ cursor: "crosshair" }}
            >
              <Layer>
                {uploadedImage && <KonvaImage image={uploadedImage} width={imageSize.width} height={imageSize.height} />}
                {placemarks.map((point, index) => (
                  <Placemark key={index} x={point.x} y={point.y} icon={icons[point.type]} />
                ))}
              </Layer>
            </Stage>
          </div>
        </div>
      )}
      <br />
      <button
        onClick={generatePDF}
        disabled={loading}
        className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 disabled:opacity-50"
      >
        {loading ? (
          <div className="flex items-center gap-2">
            <span className="loader"></span>
            {i18n.language === "ur" ? "لوڈ ہو رہا ہے..." : "Uploading..."}
          </div>
        ) : (
          <span>{i18n.language === "ur" ? "تصویر شامل کریں" : "Add Image"}</span>
        )}
      </button>

    </div>
  );
};

// Component for displaying icon images as placemarks
const Placemark = ({ x, y, icon }) => {
  const [iconImage] = useImage(icon, "anonymous");
  return <KonvaImage image={iconImage} x={x} y={y} width={30} height={30} />;
};

export default ImageEditor;
